import { FETCH_FARMS_LIST_REQUEST } from "./constants";

export function getFarms(farms: any) {
  return {
    type: FETCH_FARMS_LIST_REQUEST,
    payload: farms,
  }
}